import React from "react";
import { PropertyEditorImage, PropertyEditorImageInterface } from "../PropertyEditorImage";
import { ObserveState } from "../../StateManagement/ObserveState";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextData implements PropertyEditorImageInterface {
    editObject: object = {};
    label: string = "Image Editor";
    propertyName: string = "image";

    updateCallback = () => {
        StateManager.changed(this);
    };
}

class TextData2 implements PropertyEditorImageInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "image"), new ValidationIssue("issue 2", "image")];
        },
    };
    label: string = "Image Editor";
    propertyName: string = "image";

    updateCallback = () => {
        StateManager.changed(this);
    };
}

export const ImagePropertyEditor = [
    new StoryNode(
        () => {
            let args = new TextData();
            return (
                <ObserveState
                    listenTo={args}
                    control={() => {
                        const image = Reflect.get(args.editObject, "image");
                        return (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    maxWidth: 200,
                                }}
                            >
                                <PropertyEditorImage {...args} />
                                <img
                                    src={image}
                                    alt="PropertyEditImage"
                                />
                            </div>
                        );
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Image",
        "Default",
    ),
    new StoryNode(
        () => {
            let args = new TextData();
            return (
                <ObserveState
                    listenTo={args}
                    control={() => {
                        const image = Reflect.get(args.editObject, "image");
                        return (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    maxWidth: 200,
                                }}
                            >
                                <PropertyEditorImage
                                    {...args}
                                    error={"Error Text"}
                                />
                                <img
                                    src={image}
                                    alt="PropertyEditImage"
                                />
                            </div>
                        );
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Image",
        "Error",
    ),
    new StoryNode(
        () => {
            let args = new TextData2();
            return (
                <ObserveState
                    listenTo={args}
                    control={() => {
                        const image = Reflect.get(args.editObject, "image");
                        return (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    maxWidth: 200,
                                }}
                            >
                                <PropertyEditorImage {...args} />
                                <img
                                    src={image}
                                    alt="PropertyEditImage"
                                />
                            </div>
                        );
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Image",
        "Validation Provider",
    ),
];
